module.exports = __webpack_public_path__ + "img/Day6_upsidedown_final_lazy.73b0b822.jpg";